import React from "react";

const LEGAL_LINKS = {
  privacy:
    "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/HYNT_Privacy+Policy.pdf",
  terms:
    "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/HYNT+terms.pdf",
  cookie:
    "https://csappproduction-storage.s3.ap-south-1.amazonaws.com/static-assets/legal/Cookie+Policy.pdf",
};

function FooterContent() {
  return (
    <div className="flex w-full justify-center md:mt-16">
      <div className="w-full max-w-[1412px] flex items-start justify-between px-4 py-3 sm:items-center sm:py-2">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:truncate sm:gap-2 md:gap-[22px] lg:gap-[32px]">
          <a
            href={LEGAL_LINKS.privacy}
            className="font-nunito font-semibold md:text-[16px] text-[14px] leading-[100%] text-[#999999]"
          >
            Privacy policy
          </a>

          <a
            href={LEGAL_LINKS.cookie}
            className="font-nunito font-semibold sm:truncate md:text-[16px] text-[14px] leading-[100%] text-[#999999]"
          >
            Cookie policy
          </a>
        </div>

        <div className="flex flex-col items-end gap-2 text-right sm:flex-row sm:items-center sm:gap-6">
          <p className="font-nunito font-semibold m-0 md:text-[16px] text-[14px] leading-[100%] text-[#999999]">
            Copyright © {new Date().getFullYear()} HYNT
          </p>
          <a
            href={LEGAL_LINKS.terms}
            className="font-nunito font-semibold sm:truncate md:text-[16px] text-[14px] leading-[100%] text-[#999999]"
          >
            Terms of service
          </a>
        </div>
      </div>
    </div>
  );
}

function NewFooter({ absolute = false, inFlow = false }) {
  if (inFlow) {
    return (
      <div className="w-full mt-8">
        <FooterContent />
      </div>
    );
  }

  if (!absolute) {
    return (
      <div className="fixed bottom-0 w-full">
        <FooterContent />
      </div>
    );
  }
  return (
    <>
      <div className="hidden lg:w-[1412px] md:w-[850px] h-[54px] md:flex justify-between absolute top-[924px] lg:left-1/2 md:left-[55%] -translate-x-1/2  p-2">
        <div className=" h-[38px] flex items-center md:gap-[22px] lg:gap-[32px] p-2">
          <a
            href={LEGAL_LINKS.privacy}
            className="
        font-nunito 
        font-semibold 
        text-[16px] 
        leading-[100%]
        text-[#999999]
      "
          >
            Privacy policy
          </a>

          <a
            href={LEGAL_LINKS.cookie}
            className="
        font-nunito 
        font-semibold 
        text-[16px] 
        leading-[100%]
        text-[#999999]
      "
          >
            Cookie policy
          </a>
        </div>

        <div
          className="
      h-[38px] 
      flex items-center 
      gap-[32px] 
      p-2 
      font-nunito font-semibold 
      text-[16px] leading-[100%] 
      text-[#999999]
    "
        >
          <a
            href={LEGAL_LINKS.terms}
            className="
        font-nunito 
        font-semibold 
        text-[16px] 
        leading-[100%]
        text-[#999999]
      "
          >
            Terms of service
          </a>
        </div>
      </div>
    </>
  );
}

export default NewFooter;
